import AjaxUtils from "../../util/ajax_utils";
import { sanitizeHTML } from "../_ui/_utils/useStringUtils";

const ApckAlertsVulnCounts  = {
    // Based on ApckVulnColumnNew
    // This is an initial version
    // and might be made into a shared component in the next iteration.
    props: {
        vulnCounts: {
            type: Array,
            default: () => []
        },
    },
    computed: {
        crit() {
            return this.vulnCounts[0] ?? 0;
        },
        high() {
            return this.vulnCounts[1] ?? 0;
        },
        medium() {
            return this.vulnCounts[2] ?? 0;
        },
        low() {
            return this.vulnCounts[3] ?? 0;
        },
    },
    methods: {
        zeroClass(value) {
            // Remove zeroClass for now to experiment with rendering.
            return ''
            return value === 0 ? 'impact-zero' : '';
        }
    },
    template: `
        <div class="vuln-counts">
            <ui-tooltip content="Critical" :class="['impact impact-critical', zeroClass(crit)]">{{ crit }}</ui-tooltip>
            <ui-tooltip content="High" :class="['impact impact-high', zeroClass(high)]">{{ high }}</ui-tooltip>
            <ui-tooltip content="Medium" :class="['impact impact-medium', zeroClass(medium)]">{{ medium }}</ui-tooltip>
            <ui-tooltip content="Low" :class="['impact impact-low', zeroClass(low)]">{{ low }}</ui-tooltip>
        </div>
    `
};

export const ApckAlertsPanel = {
    components: {
        "apck-alerts-vuln-counts": ApckAlertsVulnCounts,
    },
    props: {
        src: {
            type: String,
            required: true,
            default: '/news'
        },
        title: {
            type: String,
            default: 'Alerts'
        },
        emptyStateText: {
            type: String,
            default: 'You have no new alerts'
        }
    },
    data: function() {
        return {
            alerts: [],
            loaded: false,
            showScrollMask: false,
        };
    },
    methods: {
        load(alert) {
            if (alert.url && alert.url.startsWith("/") && !alert.url.startsWith("//")) {
                window.location.href = alert.url;
            }
        },
        dismiss(alert) {
            const cmp = this;
            if (alert.dismiss_id === null || alert.dismiss_id === undefined || alert.dismiss_id === '') {
                return;
            }

            const url = `/notices/dismiss/${alert.dismiss_id}`;
            const callback = () => {
                cmp.alerts = cmp.alerts.filter(obj => obj.dismiss_id !== alert.dismiss_id);
                cmp.$nextTick(() => {
                    cmp.checkScroll();
                });
            }
            AjaxUtils.ajax_get({
                url: url,
                success: function (json, status, xhr) {
                    callback();
                },
                fail: function (json, status, xhr) {
                    callback();
                },
                opts: {no_response_message: 'There was an error loading alerts'}
            });
        },
        fetchAlerts() {
            const cmp = this;
            cmp.loaded = false;

            AjaxUtils.ajax_get({
                url: cmp.src,
                success: function (json, status, xhr) {
                    cmp.alerts = json;
                    cmp.loaded = true;
                    cmp.$nextTick(() => {
                        cmp.checkScroll();
                    });
                },
                fail: function (json, status, xhr) {
                    cmp.loaded = true;
                    cmp.$nextTick(() => {
                        cmp.checkScroll();
                    });
                },
                opts: {no_response_message: 'There was an error loading alerts'}
            });
        },
        icon: function(source) {
            let type_icon = 'fa-bell';
            let map = {
                'news':'fa-newspaper-o',
                'blog': 'fa-newspaper-o',
                'release': 'fa-tag',
                'vulnerability': 'fa-bug',
                'scanner plugin': 'fa-bug',
                'ui': 'fa-desktop'
            };
            if (map[source]) {
                type_icon = map[source];
            }
            return type_icon;
        },
        checkScroll() {
            const container = this.$refs.scrollContainer;
            this.showScrollMask = container.scrollHeight - container.scrollTop > container.clientHeight + 5;
        },
        sanitizeNotice(notice) {
            return sanitizeHTML(notice);
        },
    },
    computed: {
        newAlertCount() {
            return this.alerts.filter(alert => alert.seen === false).length;
        },
    },
    mounted: function () {
        this.fetchAlerts();
    },
    template: `
        <div class="dashboard-sidebar-panel">
            <div class="header">
                <h2 v-if="title">{{ title}}</h2>
                <div v-if="newAlertCount > 0" class="badge badge-danger">
                    {{ newAlertCount }} new alerts
                </div>
            </div>
            <div class="apck-alerts" ref="scrollContainer" @scroll="checkScroll()">
                <template v-if="!alerts.length">
                    <p>
                        {{emptyStateText}}
                    </p>
                </template>
                <template v-else>
                    <div v-for="alert in alerts" class="apck-alert" @click="load(alert)">
                        <div :class="['alert-news-icon', 'alert-color-' + alert.colour]">
                            <i :class="alert.icon"></i>
                            <div class="alert-icon-bar"></div>
                        </div>

                        <div class="alert-news-body">
                            <div class="alert-news-title">
                                <a v-if="alert.url" :href="alert.url"><h3>{{ alert.title }}</h3></a>
                                <h3 v-else>{{ alert.title }}</h3>
                                <div v-if="alert.seen === false" class="badge badge-danger">
                                    New
                                </div>
                                <div
                                    v-if="alert.dismiss_id"
                                    class="alert-dismiss"
                                    @click.stop="dismiss(alert)"
                                >
                                    Dismiss
                                </div>
                            </div>
                            <p v-if="alert.published" class="apck-news-date">
                                {{ alert.published }}
                            </p>

                            <div class="alert-text" v-html="sanitizeNotice(alert.notice)"></div>

                            <apck-alerts-vuln-counts
                                v-if="alert.vuln_counts"
                                :vuln-counts="alert.vuln_counts"
                            />
                            <div class="alert-vuln-counts"></div>

                        </div>
                    </div>
                </template>
            </div>

            <div v-show="showScrollMask" class="scroll-mask"></div>

            <apck-mask :trigger="!loaded" />
        </div>
    `
}